import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

function initSentry() {
  Sentry.init({
    dsn: "https://79e579048a304353899ce6ae8a294572@o463725.ingest.sentry.io/5778810",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,
  });
  console.log("SENTRY INITIALIZED");
}

export default initSentry;
